{
  "name": "Pedal Harp Scordatura 145-note layout",
  "description": "145-note layout for a pedal harp scordatura. The scale allows every note of the harp to be tuned individually. To match the harp pedal mechanism, notes labelled with *f and *s lower or raise the respective diatonic note by ca. 100¢. A diatonic semitone is one degree and a diatonic tone spans 4 scale degrees, so each octave comprises a 22-note isomorphic pattern covering every pedal combination. To allow independent tuning of all 47 harp strings, the 22 notes are extended to 6 1/2 octaves, and the equave is set to 1/1, causing the pattern to repeat without transposition. The layout allows the entire scale to fit comfortably on a lumatone.",
  "scale": [
    "200.",
    "7900.",
    "0.",
    "200.",
    "300.",
    "400.",
    "200.",
    "400.",
    "500.",
    "600.",
    "500.",
    "600.",
    "700.",
    "800.",
    "1200.",
    "800.",
    "900.",
    "1000.",
    "1100.",
    "1000.",
    "1100.",
    "2/1",
    "1300.",
    "1200.",
    "1300.",
    "1400.",
    "1500.",
    "1600.",
    "1500.",
    "1600.",
    "1700.",
    "1800.",
    "1700.",
    "1800.",
    "1900.",
    "2000.",
    "2400.",
    "2000.",
    "2100.",
    "2200.",
    "2300.",
    "2200.",
    "2300.",
    "4/1",
    "2500.",
    "2400.",
    "2500.",
    "2600.",
    "2700.",
    "2800.",
    "2700.",
    "2800.",
    "2900.",
    "3000.0",
    "2900.0",
    "3000.0",
    "3100.0",
    "3200.0",
    "3600.0",
    "3200.0",
    "3300.0",
    "3400.0",
    "3500.0",
    "3400.0",
    "3500.0",
    "8/1",
    "3700.0",
    "3600.0",
    "3700.",
    "3800.0",
    "3900.0",
    "4000.0",
    "3900.0",
    "4000.0",
    "4100.0",
    "4200.0",
    "4100.0",
    "4200.0",
    "4300.0",
    "4400.0",
    "4800.0",
    "4400.0",
    "4500.",
    "4600.0",
    "4700.0",
    "4600.0",
    "4700.0",
    "16/1",
    "4900.0",
    "4800.0",
    "4900.0",
    "5000.0",
    "5100.0",
    "5200.0",
    "5100.0",
    "5200.0",
    "5300.0",
    "5400.0",
    "5300.0",
    "5400.0",
    "5500.0",
    "5600.0",
    "6000.0",
    "5600.0",
    "5700.0",
    "5800.0",
    "5900.0",
    "5818.0",
    "5894.0",
    "32/1",
    "6100.0",
    "6000.0",
    "6100.0",
    "6200.0",
    "6300.0",
    "6400.0",
    "6300.0",
    "6400.0",
    "6500.0",
    "6600.0",
    "6500.0",
    "6600.0",
    "6700.0",
    "6800.0",
    "7200.0",
    "6800.0",
    "6900.0",
    "7000.0",
    "7100.0",
    "7000.0",
    "7100.",
    "64/1",
    "7300.0",
    "7200.0",
    "7300.0",
    "7400.0",
    "7500.0",
    "7600.0",
    "7500.0",
    "7600.0",
    "7700.0",
    "7900.0",
    "7700.0",
    "7800.0",
    "7900.0",
    "1/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "12-HS_A13-26no23",
  "built_in_group": "Scordatura",
  "key_labels": "note_names",
  "fundamental_color": "#ffdbe8",
  "note_names": [
    "c1",
    "",
    "",
    "",
    "d1",
    "*fe",
    "*ff",
    "",
    "e1",
    "f1",
    "*fg",
    "*se",
    "*sf",
    "g1",
    "*fa",
    "",
    "*sg",
    "a1",
    "*fb",
    "*fc",
    "*sa",
    "b1",
    "c2",
    "*fd",
    "*sb",
    "*sc",
    "d2",
    "*fe",
    "*ff",
    "*sd",
    "e2",
    "f2",
    "*fg",
    "*se",
    "*sf",
    "g2",
    "*fa",
    "",
    "*sg",
    "a2",
    "*fb",
    "*fc",
    "*sa",
    "b2",
    "c3",
    "*fd",
    "*sb",
    "*sc",
    "d3",
    "*fe",
    "*ff",
    "*sd",
    "e3",
    "f3",
    "*fg",
    "*se",
    "*sf",
    "g3",
    "*fa",
    "",
    "*sg",
    "a3",
    "*fb",
    "*fc",
    "*sa",
    "b3",
    "c4",
    "*fd",
    "*sb",
    "*sc",
    "d4",
    "*fe",
    "*ff",
    "*sd",
    "e4",
    "f4",
    "*fg",
    "*se",
    "*sf",
    "g4",
    "*fa",
    "",
    "*sg",
    "a4",
    "*fb",
    "*fc",
    "*sa",
    "b4",
    "c5",
    "*fd",
    "*sb",
    "*sc",
    "d5",
    "*fe",
    "*ff",
    "*sd",
    "e5",
    "f5",
    "*fg",
    "*se",
    "*sf",
    "g5",
    "*fa",
    "",
    "*sg",
    "a5",
    "*fb",
    "*fc",
    "*sa",
    "b5",
    "c6",
    "*fd",
    "*sb",
    "*sc",
    "d6",
    "*fe",
    "*ff",
    "*sd",
    "e6",
    "f6",
    "*fg",
    "*se",
    "*sf",
    "g6",
    "*fa",
    "",
    "*sg",
    "a6",
    "*fb",
    "*fc",
    "*sa",
    "b6",
    "c7",
    "*fd",
    "*sb",
    "*sc",
    "d7",
    "*fe",
    "*ff",
    "*sd",
    "e7",
    "f7",
    "",
    "*se",
    "*sf",
    "g7"
  ],
  "note_colors": [
    "ffbcbc",
    "d0d0d7",
    "dee2da",
    "737373",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffffff",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "737373",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffe5e5",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffffff",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "737373",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffe5e5",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffffff",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "737373",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "#ffadad",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffffff",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "737373",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffe5e5",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffffff",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "737373",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffe5e5",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffffff",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "737373",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffe5e5",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffffff",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff"
  ],
  "equivSteps": 146,
  "fundamental": 441,
  "reference_degree": 83,
  "center_degree": 44,
  "rSteps": 7,
  "drSteps": 4,
  "hexSize": 42,
  "rotation": -16.102113751,
  "lumatone_anchor_note": 8,
  "lumatone_anchor_channel": 2
}
